import { StaticImageSymbol } from "@evergis/sgis/es/symbols/point/StaticImageSymbol";
import { MaskedImage } from "@evergis/sgis/es/symbols/point/MaskedImage";
import { SymbolType, isImageSymbol, isPointSymbol } from "./getSymbolRenderers";
import { loadImage, resizeImageSize } from "../../../utils/image";
import { SYMBOL_LIMITS } from "../../../components/SymbolEditor/limits";

export function centerAlignSymbol(baseSymbol: SymbolType) {
  const symbol: SymbolType | undefined = baseSymbol && (baseSymbol.clone() as SymbolType);

  if (isImageSymbol(symbol)) {
    symbol.anchorPoint = [symbol.width / 2, symbol.height / 2];
  } else if (isPointSymbol(symbol)) {
    symbol.offset = [0, 0];
  }

  return symbol;
}

const formatStaticImageSymbol = async (baseSymbol: StaticImageSymbol, { size }: SymbolFormatOptions = {}) => {
  const maxAbleSize = Math.min(SYMBOL_LIMITS.SIZE_MAX, size || Math.max(baseSymbol.width, baseSymbol.height));
  const image = await loadImage(baseSymbol.source);
  const { height, width } = resizeImageSize(image as HTMLImageElement, maxAbleSize);

  baseSymbol.height = height;
  baseSymbol.width = width;
};

type SymbolFormatOptions = {
  size?: number;
};

export const formatSymbol = async (baseSymbol: SymbolType, options?: SymbolFormatOptions) => {
  if (baseSymbol instanceof StaticImageSymbol) {
    await formatStaticImageSymbol(baseSymbol, options);
  }

  if (baseSymbol instanceof MaskedImage) {
    return baseSymbol;
  }

  return centerAlignSymbol(baseSymbol);
};
